import React from "react";
import RouterLink from './cofig/RouterLink';
// import Navbar from './Navbar'
export default function App(props) {
  return (
    <>
    {/* <Navbar /> */}
    <RouterLink />
    </>
  );
}